module.exports = __webpack_public_path__ + "static/PFB__0000_Bike-Share-ea8b14cffaaec8a95c0c2fa289dfd231.png";